<template>
  <div class="kt-container  kt-container--fluid ">
    <div class="kt-footer__wrapper">
      <div class="kt-footer__copyright">
        2019&nbsp;&copy;&nbsp;<router-link to="/" class="kt-link">
          <span @click="trackCustomEvent({ action: 'clicked', target: 'eli_footer', linkTo: 'overview' })">
            ELI
          </span>
        </router-link>&nbsp;by&nbsp;<a
          href="https://insightera.co.th/"
          target="_blank"
          class="kt-link"
          @click="trackCustomEvent({ action: 'clicked', target: 'insightera_footer', linkTo: 'insightera' })"
        >
          InsightEra
        </a>
      </div>
      <div class="kt-footer__menu">
        <router-link to="/terms" class="kt-link">
          <span @click="trackCustomEvent({ action: 'clicked', target: 'terms_footer', linkTo: 'terms' })">
            Terms
          </span>
        </router-link>
        <router-link to="/privacypolicy" class="kt-link">
          <span @click="trackCustomEvent({ action: 'clicked', target: 'privacy_policy_footer', linkTo: 'privacypolicy' })">
            Privacy Policy
          </span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions({
      trackCustomEvent: 'user/trackCustomEvent'
    })
  }
}
</script>
